export interface StoreState {
  count: number;
}

export const initialState: StoreState = {
  count: 0,
};
